'use client';
import { useEffect } from 'react';

import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import ScarcitySection from './components/ScarcitySection';
import SpecsSection from './components/SpecsSection';

import ShippingSection from './components/ShippingSection';
import FooterSection from './components/FooterSection';
import MobileStickyCTA from './components/MobileStickyCTA';

// Product Data
const productData = {
  name: 'LUME001',
  tagline: 'Atmosphere, curated.',
  description: 'Hand-sculpted from genuine, heat-bent coconut leaves. A one-of-a-kind glow for your sanctuary. This isn\'t a mass-produced fixture; it\'s an organic installation.',
  price: '£38.88',
  retailPrice: '£59.99',
  savings: '£21.11',
  savingsPercentage: '35%',
  unitsRemaining: 942,
  totalUnits: 1000,
  imageUrl: "/assets/images/1847065-1771275526270.jpeg",
  imageAlt: 'Artisan-crafted coconut glow lamp with curved wooden stand and glowing spherical coconut leaf shade',
  checkoutUrl: '#checkout'
};

const specifications = [
{ id: 'spec_1', label: 'PRODUCT_ID', value: 'LUME001' },
{ id: 'spec_2', label: 'MATERIAL', value: 'RECLAIMED COCONUT LEAF' },
{ id: 'spec_3', label: 'ORIGIN', value: 'BALI (ARTISAN HAND-BENT)' },
{ id: 'spec_4', label: 'DISPATCH', value: '7-10 Working Days tracked delivery' },
{ id: 'spec_5', label: 'DIMENSIONS', value: '35CM × 35CM × 45CM' },
{ id: 'spec_6', label: 'WEIGHT', value: '1.2KG (LIGHTWEIGHT)' },
{ id: 'spec_7', label: 'BULB', value: 'E27 LED (NOT INCLUDED)' },
{ id: 'spec_8', label: 'WARRANTY', value: '12-MONTH ARTISAN GUARANTEE' }];


const brandStory = {
  name: 'LUME001',
  mission: 'Bridging the gap between raw nature and modern software aesthetics.',
  description: 'We source reclaimed materials and use heat-bending techniques to create silhouettes that can\'t be replicated by machines. Each piece is a testament to artisan skill, environmental responsibility, and timeless design.'
};

export default function Homepage() {
  // Scroll reveal animation setup
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals?.length) return;

    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    );
    reveals?.forEach((el) => observer?.observe(el));

    return () => observer?.disconnect();
  }, []);

  return (
    <main className="min-h-screen bg-background">
      {/* Hero Section */}
      <HeroSection
        productName={productData?.name}
        tagline={productData?.tagline}
        description={productData?.description}
        price={productData?.price}
        unitsRemaining={productData?.unitsRemaining}
        totalUnits={productData?.totalUnits}
        imageUrl={productData?.imageUrl}
        imageAlt={productData?.imageAlt} />
      
      {/* Brand Story - Moved directly under Hero */}
      <StorySection
        brandName={brandStory?.name}
        mission={brandStory?.mission}
        description={brandStory?.description} />
      
      {/* Scarcity Counter */}
      <ScarcitySection
        batchName="BATCH 001: THE FIRST 1,000"
        unitsRemaining={productData?.unitsRemaining}
        totalUnits={productData?.totalUnits}
        urgencyMessage="Once Batch 001 is exhausted, this design will never be restocked. Secure your unit now or miss out permanently." />
      
      {/* Technical Specifications - Now merged with Comparison */}
      <SpecsSection specifications={specifications} />
      
      {/* Shipping Bar - Compact version */}
      <ShippingSection />
      
      {/* Footer */}
      <FooterSection />
      {/* Mobile Sticky CTA */}
      <MobileStickyCTA
        price={productData?.price}
        checkoutUrl={productData?.checkoutUrl} />
    </main>
  );

}